import { useState, useEffect } from 'react';
import { useLocation, useHistory} from 'react-router-dom';
import { requireAdmin } from '../middleware/requireAdmin';

export const useAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const checkAdmin = async () => {
      if (location.pathname.startsWith('/admin')) {
        try {
          const adminStatus = await requireAdmin();
          if (adminStatus === false) {
            alert('管理者権限がありません');
            history.push('/');
          }
          setIsAdmin(adminStatus);
        } catch (error) {
          history.push('/');
          setIsAdmin(false);
        }
      }
      setLoading(false);
    };

    checkAdmin();
  }, [location.pathname, history]);

  return { isAdmin, loading };
};